import React, { Component } from 'react';
import PropTypes from "prop-types";

import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ImageCarouselView from "./ImageCarouselView";

export default class AdvertisementDetailsPreviewView extends Component {

    static propTypes = {
        advertisementId: PropTypes.number.isRequired,
        memberId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        statusId: PropTypes.number.isRequired,
        statusName: PropTypes.string.isRequired,
        created: PropTypes.number.isRequired,
        updated: PropTypes.number.isRequired,
        deleted: PropTypes.bool.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
     };

    render() {
        return (
            <div className="card mb-2">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="card-title">
                                {this.props.title}
                                <button
                                    type="button"
                                    className="btn btn-primary float-right"
                                    onClick={this.handleEditAdvertisementClick}
                                >
                                    <i className="fas fa-edit mr-1" />
                                    Edit
                                </button>
                            </h2>
                        </div>
                    </div>
                    <div className="card-body" id={this.props.advertisementId}>
                        <div className="row">
                            <div className="col-12">
                                <ImageCarouselView id={this.props.advertisementId} imageNames={this.props.imageNames} imageClassName="card-img-view-advertisement"/>
                            </div>
                        </div>
                        <h4>Description</h4>
                        <p className="card-text shadow p-3 bg-white rounded">{this.props.description}</p>
                    </div>
                </div>
            </div>
        );
    }

    handleEditAdvertisementClick = () => {
        EventPublisher.publish(UIInteractionEvents.PREVIEW_ADVERTISEMENT_EDIT_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: this.props.advertisementId});
    };
}

